<template>
  <div class="QuizSelect">
    <v-select v-model="response" :dir="'auto'" :clearable="false" :searchable="false" :options="answers" @input="onSelect" placeholder="Sélectionnez votre réponse" v-if="!$tools.isTouchDevice()"></v-select>
    <select @change="onSelect" v-model="response" class="QuizSelect_select" v-else>
      <option disabled value="">Sélectionnez votre réponse</option>
      <option v-for="(answer, index) in answers" :key="index" :value="answer.id">{{ answer.label }}</option>
    </select>
    <i class="far fa-chevron-down" v-if="$tools.isTouchDevice()"></i>
  </div>
</template>

<script>

  export default {
    name: "QuizSelect",
    props: [ 'answers' ],
    data() {
      return {
        response: ''
      }
    },
    methods: {
      onSelect()
      {
        let selectId = this.response.id ? this.response.id : this.response
        this.$emit('fieldOk', { id: selectId })
      }
    },
    created()
    {

    }
  }
</script>

<style lang="stylus">
.QuizSelect

  position relative
  margin auto
  width 100vw
  max-width 590px
  box-sizing border-box

  @media $medium

    width 100%

  &_select, .vs__dropdown-toggle

    background: white
    border 0px
    appearance none
    box-sizing border-box
    width 100%
    height 75px
    padding 0px 60px 0px 30px
    box-shadow: 0 2px 20px 0 rgba(0,0,0,0.06);
    border-radius: 5px;
    font-family $f-title
    font-size: 14px;
    color: $blue
    letter-spacing: -0.3px;
    line-height: 14px;
    font-weight 500

    @media $xsmall

      padding 0px 40px 0px 15px
      font-size 12px
      line-height 12px

  .vs--single.vs--open .vs__selected

    position relative

  .vs__selected, .vs__search, .vs__dropdown-option

    font-family $f-title
    font-size: 14px;
    color: $blue
    letter-spacing: -0.3px;
    line-height: 14px;
    margin 0px 0px
    font-weight 500

    @media $xsmall

      padding 0px 30px 15px
      font-size 12px
      line-height 12px

  .vs__dropdown-option

    padding 5px 40px

    @media $xsmall

      padding 15px 20px

  .vs__dropdown-option--highlight

    background-color $n2

  .vs__open-indicator

    fill $blue

  .vs__actions

    position absolute
    top 0px
    right 35px
    height 100%

  &_withIllustration

    .vs__dropdown-menu

      bottom calc(100% - 1px)
      top auto
      z-index 0

  i

    position absolute
    color $blue
    font-size 18px
    right 30px
    top 50%
    pointer-events none
    transform translateY(-50%)

    @media $xsmall

      right 15px
</style>
